import { createContext, useContext, ReactNode } from 'react';
import { usePageVisibility } from '@/shared/hooks';

interface PageVisibilityContextType {
  isVisible: boolean;
}

const PageVisibilityContext = createContext<PageVisibilityContextType | undefined>(undefined);

export function usePageVisibilityContext() {
  const context = useContext(PageVisibilityContext);
  if (context === undefined) {
    throw new Error('usePageVisibilityContext deve ser usado dentro de PageVisibilityProvider');
  }
  return context;
}

interface PageVisibilityProviderProps {
  children: ReactNode;
}

export function PageVisibilityProvider({ children }: PageVisibilityProviderProps) {
  const isVisible = usePageVisibility();

  return (
    <PageVisibilityContext.Provider value={{ isVisible }}>
      {children}
    </PageVisibilityContext.Provider>
  );
} 